import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";

import { getRouteInfoFromRouteName } from "routes/config";

const ScrollToTop: React.FC<RouteComponentProps> = ({ history }) => {
  const [timer, setTimer] = React.useState<NodeJS.Timeout>(null);

  React.useEffect(() => {
    const unlisten = history.listen(location => {
      const { scrollToTop } = getRouteInfoFromRouteName(
        location.pathname,
      ).config;
      scrollToTop &&
        setTimer(
          setTimeout(
            () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
            200,
          ),
        );
    });
    return () => {
      unlisten();
      clearTimeout(timer);
    };
  }, [timer, history]);

  return null;
};

export default withRouter(ScrollToTop);
